module.exports = __webpack_public_path__ + "fonts/io.420b804.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/flags/io.svg
// module id = 728
// module chunks = 0